import debounce from 'lodash.debounce';
import { MapPolygonEvent } from '../../../enums';
import BaseShape from './BaseShape';

const CHANGE_DEBOUNCE_TIME = 300;

export default class Polygon extends BaseShape {
  draw(paths, drawingOptions) {
    if (paths.length) {
      this.area = new this.googleMaps.Polygon({
        ...drawingOptions.polygonOptions,
        paths,
      });
      this.area.setMap(this.map);
    } else {
      this.clear();
    }
  }

  addListener(callback) {
    const { area } = this;

    if (area) {
      const listener = debounce(
        () => { callback(Polygon.getAreaBounds(area)); },
        CHANGE_DEBOUNCE_TIME,
      );

      Object.values(MapPolygonEvent)
        .forEach((eventType) => area.getPath().addListener(eventType, listener));
    }
  }

  static getAreaBounds(area) {
    return area.getPath().getArray().map((bound) => bound.toJSON());
  }
}
